import { Heading, Icon } from '@assembly-js/design-system';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import clsx from 'clsx';
import React from 'react';

interface PageTitleMenuButtonProps {
  title: string;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
}

export const PageTitleMenuButton = React.forwardRef<
  HTMLSpanElement,
  PageTitleMenuButtonProps
>(({ title, onClick, className }, ref) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        // the negative margin is used to align the title text with the page content elements
        'flex items-center gap-2 p-1 px-2 rounded bg-transparent border-0 cursor-pointer hover:bg-primary-hover -ml-2 min-w-0 overflow-hidden',
        isMobile && 'max-w-full',
        className,
      )}
    >
      <span ref={ref} className="min-w-0">
        <Heading size="sm" className="truncate">
          {title}
        </Heading>
      </span>
      <Icon icon="ChevronDown" className="w-3 h-3 shrink-0 text-secondary" />
    </button>
  );
});
PageTitleMenuButton.displayName = 'PageTitleMenuButton';
